<template>
  <div v-if="pages > 1" class="pageDiv">
    <a v-if="page > 1" href="javascript:;" @click.prevent="change(page - 1)">
      <i class="font_family icon-zuojiantou"></i>
    </a>
    <template v-for="p in pageNumbers">
      <span v-if="p === page" :key="'cur-' + p">{{ p }}</span>
      <a v-else :key="'link-' + p" href="javascript:;" @click.prevent="change(p)">{{ p }}</a>
    </template>
    <a v-if="page < pages" href="javascript:;" @click.prevent="change(page + 1)">
      <i class="font_family icon-youjiantou"></i>
    </a>
  </div>
</template>

<script>
import { buildPageNumbers, totalPages } from '@/utils/pagination'

export default {
  name: 'PagePagination',
  props: {
    page: { type: Number, default: 1 },
    total: { type: Number, default: 0 },
    pageSize: { type: Number, default: 6 }
  },
  computed: {
    pages() {
      return totalPages(this.total, this.pageSize)
    },
    pageNumbers() {
      return buildPageNumbers(this.page, this.pages)
    }
  },
  methods: {
    change(next) {
      if (next < 1 || next > this.pages || next === this.page) return
      this.$emit('change', next)
    }
  }
}
</script>

<style scoped>
.pageDiv {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 30px 0 0;
}

.pageDiv a,
.pageDiv span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  margin: 0;
  line-height: 1;
  border-radius: 4px;
  font-size: 16px;
  color: #333;
  background: #f5f5f5;
}

.pageDiv span {
  color: #fff;
  background: #ee7700;
}

.pageDiv i {
  font-size: 14px;
}

@media (max-width: 768px) {
  .pageDiv a,
  .pageDiv span {
    width: 30px;
    height: 30px;
    font-size: 14px;
  }
}
</style>
